import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const reviews = [
  {
    name: "Nikhil Vadgama",
    time: "2 yrs",
    response: "Delicious taste of all products Specially for round kachori and Gulab paak",
  },
  {
    name: "Jeet Mehta",
    time: "2 months",
    response: "One of the best places in Jamnagar for namkeen and kachori! Kuku Namkeen never disappoints - everything tastes fresh, crispy, and perfectly spiced. Their kachori is especially amazing, super crunchy outside with a flavorful filling inside. You can really tell they maintain quality in every batch. Definitely my go-to spot for snacks!",
  },
  {
    name: "Vivek Dholakiya",
    time: "2 months",
    response: "Kuku Namkeen is a solid place in Jamnagar for quick snacks and especially kachori. The kachori has a nice crisp outside and good flavor inside, not overly oily like many places. Their namkeen range is also fresh and consistent. Prices are reasonable for the quality you get. Worth visiting if you want reliable taste without disappointment.",
  },
  {
    name: "Shreya Vaghani",
    time: "3 months",
    response: "Tried dryfruit kachori at Kuku Namkeen and honestly it was so good, perfectly crispy and full of flavour. Definitely one of my go-to spots for namkeen in Surat now.",
  },
  {
    name: "Tarun Ghatalia",
    time: "2 yrs",
    response: "Amazing product... best taste.... very good hygiene....",
  },
  {
    name: "Joshi Kaushal",
    time: "4 yrs",
    response: "Very tasty Kachori must try once And will continue forever for sure",
  },
  {
    name: "Nikhil Chhichhia",
    time: "1 yr",
    response: "Best Namkeen & 4 different types of dry kachori. Most important they are using oil once in one batch.",
  },
  {
    name: "Khamir Purohit",
    time: "2 yrs",
    response: "Wonderful taste. Good quality products. Tried it in Jamnagar and have been ordering in Mumbai for a few years.",
  },
  {
    name: "Navnit Boda",
    time: "6 yrs",
    response: "One of the Best Kachori at JAMNAGAR . Testy . Crunchy . Well prepared and 100% Hygiene . Well packed . Wishing all Success to Vasu Brothers .",
  },
  {
    name: "Prasad R. Sampat",
    time: "3 yrs",
    response: "Excellent kachori. Very tasty and fresh.",
  },
  {
    name: "Mitesh Khandar",
    time: "2 yrs",
    response: "Best kakhori in jamnagar",
  },
];

const ReviewsSection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("active");
          } else {
            e.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.2 }
    );
    const el = sectionRef.current;
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="hp-section hp-reveal" ref={sectionRef} style={{ background: "var(--kuku-tint)", position: "relative", overflow: "hidden" }}>
      <div className="container mx-auto px-4 md:px-4">
        <div className="hp-reviews-layout">
          {/* Left Tag */}
          <div className="new-width w-full mx-auto">
            <div className="hp-reviews-tag">
              <h2 className="text-white font-black leading-tight text-3xl md:text-4xl mb-3">Words from<br />Tastelovers</h2>
              <img
                src="/kuku-assets/images/reviews.png"
                alt="Reviews"
                style={{ width: "50%" }}
                className="mt-4"
              />
            </div>
          </div>

          {/* Right Slider */}
          <div className="hp-reviews-right">
            <Slider {...sliderSettings}>
              {reviews.map((r, i) => (
                <div key={i} className="hp-review-slide">
                  <div className="hp-review-card">
                    {i === 2 && (
                      <img
                        src="/kuku-assets/images/quote-left.png"
                        width="40"
                        alt="quote"
                        className="mb-3 opacity-20"
                      />
                    )}
                    <p className="hp-review-text">{r.response}</p>
                    <div className="hp-review-author-wrap">
                      <img
                        src="/kuku-assets/images/admin-placeholder.png"
                        alt={r.name}
                        className="hp-review-avatar"
                      />
                      <div>
                        <h6 className="hp-review-name">
                          {r.name}
                        </h6>
                        <span className="hp-review-date">{r.time}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
